import React from "react";
import { Switch, Route } from "react-router-dom";
import { StartPage } from "./StartPage/StartPage";
import { ModePage as Hw3ModePage } from "./ModePage/Hw3ModePage";
import { ModePage as Hw2ModePage } from "./ModePage/Hw2ModePage";
import { ModePage as Hw1ModePage } from "./ModePage/Hw1ModePage";
import { usePathCreator } from "./Config/useLinkCreator";
import { SchedulePage } from "./SchedulePage/SchedulePage";
import { ScheduleDayPage } from "./ScheduleDayPage/ScheduleDayPage";
import { HelpPage } from "./HelpPages/HelpPage";
import { FAQPage } from "./HelpPages/FAQPage";
import { AdvicesPage } from "./HelpPages/AdvicesPage";
import { InfoPage } from "./InfoPage/InfoPage";
import { HWSPage } from "./HWSPage/HWSPage";
import { UserServiceMenu } from "./ServiceMenuScreen/UserServiceMenu";
export function DeviceRouter(_ref) {
  var children = _ref.children,
      hardwareInfo = _ref.hardwareInfo;
  var pathCreator = usePathCreator();
  var controllerApi = hardwareInfo.controllerApi;
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/"),
    component: StartPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/info"),
    component: InfoPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/user-service-menu"),
    component: UserServiceMenu
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/help"),
    component: HelpPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/help/faq"),
    component: FAQPage
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/help/advices"),
    component: AdvicesPage
  }), controllerApi === "hw1" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/modes"),
    component: Hw1ModePage
  }), controllerApi === "hw1" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/hws"),
    component: HWSPage
  }), controllerApi === "hw1" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/schedule"),
    component: SchedulePage
  }), controllerApi === "hw1" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/schedule/:dayOfWeek"),
    component: ScheduleDayPage
  }), controllerApi === "hw2" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/modes"),
    component: Hw2ModePage
  }), controllerApi === "hw3" && /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: pathCreator("/modes"),
    component: Hw3ModePage
  }), children);
}